import React from 'react';
import { Link } from 'react-router-dom';
import { TableCell, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { convertTokens } from '@date-fns/upgrade/v2';

import { red } from 'utils/color-styles';
import { CurrencyCode, currencyFormat } from 'utils/currencyFormat';

import { TransactionTypeLabels } from '../constants';
import { Transaction } from '../types';

import { TransactionTableRow } from './TransactionTableRow';

export const GivingAccountTransferOutboundTransactionRow = ({
  transaction,
  accountCurrency,
}: {
  transaction: Extract<Transaction, { __typename: 'GivingAccountTransferOutbound' }>;
  accountCurrency: CurrencyCode;
}) => {
  const targetAmount = transaction.GivingAccountTransferInbound?.amount;
  const targetCurrency = transaction.GivingAccountTransferInbound?.GivingAccount
    .currencyCode as CurrencyCode;
  const rate = targetAmount ? targetAmount / transaction.amount : null;

  return (
    <TransactionTableRow
      collapsibleContent={
        rate &&
        targetAmount && (
          <>
            <Typography variant="body2" style={{ fontWeight: 500 }}>
              Exchange rate
            </Typography>
            <br />
            <Typography variant="body2">
              {currencyFormat(transaction.amount, accountCurrency)} ={' '}
              {currencyFormat(targetAmount, targetCurrency)}
            </Typography>
            <br />
            <Typography variant="body2">
              {currencyFormat(1, accountCurrency)} = {currencyFormat(rate, targetCurrency)}
            </Typography>
          </>
        )
      }
    >
      <TableCell style={{ paddingLeft: 0 }}>
        <Typography variant="body2">
          {format(new Date(transaction.createdAt), convertTokens('MMM DD, YYYY'))}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{TransactionTypeLabels[transaction.__typename]}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          To{' '}
          <Link
            to={`/donations/ledger/${transaction.GivingAccountTransferInbound?.GivingAccount.id}`}
          >
            {transaction.GivingAccountTransferInbound?.GivingAccount.provider}/
            {transaction.GivingAccountTransferInbound?.GivingAccount.currencyCode}
          </Link>
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {transaction.GivingAccountTransferInbound?.GivingAccount.provider}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" style={{ color: red }}>
          -{currencyFormat(transaction.amount, accountCurrency)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {typeof transaction.balance === 'number' &&
            currencyFormat(transaction.balance, accountCurrency)}
        </Typography>
      </TableCell>
      <TableCell />
    </TransactionTableRow>
  );
};
